import { render } from "./DoctorLoginPage.vue?vue&type=template&id=4089b081&scoped=true&ts=true"
import script from "./DoctorLoginPage.vue?vue&type=script&lang=ts"
export * from "./DoctorLoginPage.vue?vue&type=script&lang=ts"

import "./DoctorLoginPage.vue?vue&type=style&index=0&id=4089b081&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4089b081"]])

export default __exports__